var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.5C9.57107 1.5 11.25 3.17893 11.25 5.25C11.25 7.32107 9.57107 9 7.5 9C5.42893 9 3.75 7.32107 3.75 5.25C3.75 3.17893 5.42893 1.5 7.5 1.5ZM7.5 0C4.6005 0 2.25 2.35051 2.25 5.25C2.25 8.1495 4.6005 10.5 7.5 10.5C10.3995 10.5 12.75 8.1495 12.75 5.25C12.75 2.35051 10.3995 0 7.5 0ZM15 21H13.5V17.25C13.5 15.1789 11.8211 13.5 9.75 13.5H5.25C3.17893 13.5 1.5 15.1789 1.5 17.25V21H0V17.25C0 14.3505 2.35051 12 5.25 12H9.75C12.6495 12 15 14.3505 15 17.25V21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f484ea17b095df1a06b7e7e1bac122ec.svg";
export { ForwardRef as ReactComponent };